"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MGRSUtils = void 0;
const grid_js_1 = require("@ngageoint/grid-js");
const MGRSConstants_1 = require("./MGRSConstants");
/**
 * Military Grid Reference System utilities
 */
class MGRSUtils {
    /**
     * Validate the zone number
     *
     * @param zoneNumber
     *            zone number
     */
    static validateZoneNumber(zoneNumber) {
        if (zoneNumber < MGRSConstants_1.MGRSConstants.MIN_ZONE_NUMBER || zoneNumber > MGRSConstants_1.MGRSConstants.MAX_ZONE_NUMBER) {
            throw new Error('Illegal zone number (expected ' +
                MGRSConstants_1.MGRSConstants.MIN_ZONE_NUMBER +
                ' - ' +
                MGRSConstants_1.MGRSConstants.MAX_ZONE_NUMBER +
                '): ' +
                zoneNumber);
        }
    }
    /**
     * Validate the band letter
     *
     * @param letter
     *            band letter
     */
    static validateBandLetter(letter) {
        if (letter.charCodeAt(0) < MGRSConstants_1.MGRSConstants.MIN_BAND_LETTER.charCodeAt(0) ||
            letter.charCodeAt(0) > MGRSConstants_1.MGRSConstants.MAX_BAND_LETTER.charCodeAt(0) ||
            grid_js_1.GridUtils.isOmittedBandLetter(letter)) {
            throw new Error('Illegal band letter (CDEFGHJKLMNPQRSTUVWX): ' + letter);
        }
    }
    /**
     * Get the next band letter
     *
     * @param letter
     *            band letter
     * @return next band letter, 'Y' ({@link MGRSConstants#MAX_BAND_LETTER} + 1)
     *         if no next bands
     */
    static nextBandLetter(letter) {
        MGRSUtils.validateBandLetter(letter);
        let charLetter = letter.charCodeAt(0);
        charLetter++;
        if (grid_js_1.GridUtils.isOmittedBandLetter(String.fromCharCode(charLetter))) {
            charLetter++;
        }
        return String.fromCharCode(charLetter);
    }
    /**
     * Get the previous band letter
     *
     * @param letter
     *            band letter
     * @return previous band letter, 'B' ({@link MGRSConstants#MIN_BAND_LETTER}
     *         - 1) if no previous bands
     */
    static previousBandLetter(letter) {
        MGRSUtils.validateBandLetter(letter);
        let charLetter = letter.charCodeAt(0);
        charLetter--;
        if (grid_js_1.GridUtils.isOmittedBandLetter(String.fromCharCode(charLetter))) {
            charLetter--;
        }
        return String.fromCharCode(charLetter);
    }
    /**
     * Get the label name
     *
     * @param zoneNumber
     *            zone number
     * @param bandLetter
     *            band letter
     * @return name
     */
    static getLabelName(zoneNumber, bandLetter) {
        return zoneNumber + bandLetter;
    }
    /**
     * Get the hemisphere from the band letter
     *
     * @param bandLetter
     *            band letter
     * @return hemisphere
     */
    static getHemisphere(bandLetter) {
        return bandLetter < MGRSConstants_1.MGRSConstants.BAND_LETTER_NORTH ? grid_js_1.Hemisphere.SOUTH : grid_js_1.Hemisphere.NORTH;
    }
}
exports.MGRSUtils = MGRSUtils;
//# sourceMappingURL=MGRSUtils.js.map